'use strict';

import config from 'config';
import React, { Component } from 'react';
import CardContainer from 'components/CardContainer';
import MessageSvg from 'components/MessageSvg';
import ActionButton from 'components/ActionButton';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import zChat from 'vendor/web-sdk';

const { LABELS } = config;

class OfflineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sent: false
    };
    this.send = this.send.bind(this);
    this.sendAnother = this.sendAnother.bind(this);
    this.renderChild = this.renderChild.bind(this);
    this.onInvalid = this.onInvalid.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
  }

  onFocusIn(event) {
    const pInput = event.target.parentNode.parentNode;

    pInput.classList.add( 'yith-field-filled' );
  }

  onFocusOut(event) {
    const pInput = event.target.parentNode.parentNode,
        input = pInput.querySelector( 'input, textarea' );

    this.removeError( event.target );

    if ( ! input.value ) {
      pInput.classList.remove( 'yith-field-filled' );
    }
  }

  onInvalid( event ) {
    const input = event.target;

    this.reportError( input );
  }

  removeError( node ) {
    if ( !! node.target ) {
      node = node.target;
    }
    const pInput = node.parentNode.parentNode;

    if ( ! pInput ) {
      return;
    }

    pInput.classList.remove( 'yith-field-required' );
  }

  reportError( node ) {
    if ( !! node.target ) {
      node = node.target;
    }
    const pInput = node.parentNode.parentNode;

    if ( ! pInput ) {
      return;
    }

    pInput.classList.add( 'yith-field-required' );
  }

  send(event) {
    event.preventDefault();

    // check specifically for hidden checkboxes
    if ( ! this.refs.policy_chat.checked ) {
      this.reportError( this.refs.policy_chat );
    }

    // Use HTML form validation to validate inputs
    const form = this.refs.form;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    zChat.sendOfflineMsg({
      name: this.refs.name.value,
      email: this.refs.email.value,
      message: this.refs.message.value
    }, (err) => {
      if ( err ) {
        return;
      }

      this.setState( {
        sent: true
      } );

      // send event for Offline msg chat
      ( 'undefined' !== typeof gtag ) && gtag( 'event', { // eslint-disable-line no-undef
        event_category: 'Zopim Livechat',
        event_action: 'Offline Message Sent'
      } );
    });
  }

  sendAnother() {
    this.setState({
      sent: false
    });
  }

  renderChild() {
    if (this.state.sent) {
      return (
        <div key="sent" className="offline-sent">
          {LABELS.offline_msg_success || 'Your message has been sent. We will get back to you as soon as possible.'}
          <ActionButton
            addClass="button-resend"
            label={LABELS.send_another || 'Send another'}
            onClick={this.sendAnother}
          />
        </div>
      );
    }
    else {
      return (
        <form ref="form" key="not-sent" className="offline-form">
          <div className="form-content">
            <p className={`form-row form-row-wide ${this.props.userName ? 'yith-field-filled' : ''}`}>
              <label className="label">
                {LABELS.name_field_label || 'Name'}
                <abbr className="required" title="required">*</abbr>
              </label>
              <span className="woocommerce-input-wrapper">
                <input className="input-text" required type="text" ref="name" maxLength="255" onFocus={this.onFocusIn} onBlur={this.onFocusOut} onInvalid={this.onInvalid} defaultValue={this.props.userName} />
              </span>
            </p>
            <p className={`form-row form-row-wide ${this.props.userEmail ? 'yith-field-filled' : ''}`}>
              <label className="label">
                {LABELS.email_field_label || 'Email'}
                <abbr className="required" title="required">*</abbr>
              </label>
              <span className="woocommerce-input-wrapper">
                <input className="input-text" required ref="email" type="email" pattern={`${zChat.EMAIL_REGEX.source}`} onFocus={this.onFocusIn} onBlur={this.onFocusOut} onInvalid={this.onInvalid} defaultValue={this.props.userEmail} />
              </span>
            </p>
            <p className="form-row form-row-wide">
              <label className="label">
                {LABELS.message_field_label || 'Message'}
                <abbr className="required" title="required">*</abbr>
              </label>
              <span className="woocommerce-input-wrapper">
                <textarea className="input-text" required ref="message" onFocus={this.onFocusIn} onBlur={this.onFocusOut} onInvalid={this.onInvalid} />
              </span>
            </p>
            <p className="terms-section">
              <label className="policy-chat">
                <input type="checkbox" ref="policy_chat" value="yes" onChange={this.removeError} required data-cons-preference="privacy_policy"/>
                <span>&nbsp;</span>
                {LABELS.policy_field_label || 'I have read and accept the'} <strong><a href="#" rel="nofollow" data-toggle="modal" data-type="privacy-policy" title={LABELS.policy_field_title || 'Our Privacy Policy'}>{LABELS.policy_field_anchor || 'Privacy Policy'}</a></strong>.
              </label>
            </p>
          </div>
          <div className="button-container">
            <ActionButton
              addClass="button-send btn btn-flat-green"
              label={LABELS.offline_msg_submit || 'Send'}
              onClick={this.send}
            />
          </div>
        </form>
      );
    }
  }

  render() {
    return (
      <CardContainer addClass="offline-card" contentAddClass={this.state.sent ? 'sent' : ''} icon={ <MessageSvg /> } title={LABELS.offline_msg || 'Sorry, we are offline at the moment. Please leave us your contact information and we will get back to you soon!'}>
        <ReactCSSTransitionGroup
          className="offline-container"
          transitionName={this.state.sent ? 'offline-shrink' : 'offline-grow'}
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}>
          {this.renderChild()}
        </ReactCSSTransitionGroup>
      </CardContainer>
    );
  }
}


OfflineForm.displayName = 'OfflineForm';
OfflineForm.propTypes = {
  onClick: React.PropTypes.func,
  addClass: React.PropTypes.string
};

export default OfflineForm;



// WEBPACK FOOTER //
// ./src/components/OfflineForm.js